
export default {
  name: 'sgh-disclaimer',

  props: {
    readMore: {
      type: String,
      default() {
        return 'Read more'
      },
    },
  },

  data() {
    return {
      isPopupDisplayed: false,
      popupText: '',
    }
  },

  computed: {
    isDesktop() {
      return this.$mq !== 'tablet' && this.$mq !== 'tabletLandscape'
    },
  },
  mounted() {
    // constuct read more and popup for mobile
    if (!this.isDesktop) {
      // eslint-disable-next-line
      const textElm = $(this.$slots.default[0].elm).find('.espot span')[0]
      let innerText = textElm.innerHTML

      this.popupText = innerText
      textElm.innerHTML = innerText.substring(0, 126) + '... '

      const readMore = document.createElement('span')
      readMore.classList.add('underline')
      readMore.appendChild(document.createTextNode(this.readMore))
      textElm.appendChild(readMore)
    }
  },
  methods: {
    togglePopup() {
      if (!this.isDesktop) {
        this.isPopupDisplayed = !this.isPopupDisplayed
      }
    },
  },
}
